import { Modal, TextInput, NumberInput, Group, Button, Stack, ScrollArea } from '@mantine/core';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createTheater, updateTheater } from '../../../../redux/reducers/theaterSlice';
import { Theater } from '../../../../models/theater.model';
import { useMediaQuery } from '@mantine/hooks';

interface AddTheaterProps {
  opened: boolean;
  onClose: () => void;
  activeTheater: Theater | null;
}

function AddEditTheater({ opened, onClose, activeTheater }: AddTheaterProps) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 50em)');
  const emptyTheater: Partial<Theater> = {
    theater_name: '',
    location: '',
    default_max_seats: 0
  };
  const [theater, setTheater] = useState<Partial<Theater>>(emptyTheater);

  const handleSubmit = () => {
    if (theater.theater_name && theater.location && theater.default_max_seats) {
      if (activeTheater) {
        dispatch(updateTheater({
          id: activeTheater._id as any, theater: {
            theater_name: theater.theater_name,
            location: theater.location,
            default_max_seats: theater.default_max_seats
          }
        } as any));
      } else {
        dispatch(createTheater(theater as any));
      }
      onClose();
      setTheater(emptyTheater);
    }
  };

  useEffect(() => {
    if (activeTheater) {
      setTheater({
        theater_name: activeTheater.theater_name,
        location: activeTheater.location,
        default_max_seats: activeTheater.default_max_seats
      });
    } else {
      setTheater(emptyTheater);
    }
  }, [activeTheater]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={activeTheater ? 'Edit Theater' : 'Add New Theater'}
      size="lg"
      radius="md"
      fullScreen={isMobile}
      transitionProps={{ transition: 'fade', duration: 200 }}
      scrollAreaComponent={ScrollArea.Autosize}
      removeScrollProps={{ allowPinchZoom: true }}
    >
      <Stack gap="md">
        <TextInput
          label="Theater Name"
          placeholder="Enter theater name"
          value={theater.theater_name}
          onChange={(e) => setTheater({ ...theater, theater_name: e.target.value })}
          required
        />
        <TextInput
          label="Location"
          placeholder="Enter location"
          value={theater.location}
          onChange={(e) => setTheater({ ...theater, location: e.target.value })}
          required
        />
        <NumberInput
          label="Maximum Seats"
          placeholder="Enter maximum seats"
          value={theater.default_max_seats}
          onChange={(value) => setTheater({ ...theater, default_max_seats: Number(value) })}
          min={0}
          required
        />
      </Stack>
      <Group justify="flex-end" mt="md">
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit}>{activeTheater ? 'Update Theater' : 'Create Theater'}</Button>
      </Group>
    </Modal>
  );
}

export default AddEditTheater; 